import { Component, Inject, Input, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { HelpsService } from '../../services/helps.service';
import { ActivatedRoute } from '@angular/router';
import { DateAdapter, MAT_DATE_LOCALE, MatOption } from '@angular/material/core';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'tw-langs',
    templateUrl: './langs.component.html',
    styleUrls: ['./langs.component.css'],
    imports: [MatFormField, MatSelect, FormsModule, MatOption, MatButton]
})
export class LangsComponent implements OnInit {
    @Input() languageSupported: string[] = [];
    @Input() appType: string = 'sale';
    selectedValue: string;


    constructor(public translate: TranslateService,
                public helpsService: HelpsService,
                private activatedRoute: ActivatedRoute,
                private _adapter: DateAdapter<any>,
                @Inject(MAT_DATE_LOCALE) private dateLocale: string
                ) {
        if (!this.languageSupported) {
            this.languageSupported = [];
            this.languageSupported.push('en');
            this.languageSupported.push('fr');
        }
        this.selectedValue = this.translate.currentLang;
        //console.log(this.translate.currentLang)
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

            this.selectedValue = event.lang;
        });
    }

    ngOnInit() {
        let lang = this.activatedRoute.snapshot.paramMap.get('lang');
        if (!lang) {
            lang = 'en';
        }
        this.updateDateLocale(lang);

        this.selectedValue = lang;
    }

    selectChange(val) {
        this.translate.use(val);
        if (this.appType === 'sale') {
            this.helpsService.selectChange(val);
        }

    }

    updateDateLocale(lang: string) {
        const locale = lang === 'fr' ? 'fr-FR' : 'en-US';
        // Update the date locale dynamically
        this.dateLocale = locale;
        this._adapter.setLocale(this.dateLocale);
        console.log('Updated Date Locale:', this.dateLocale);
    }
}
